<template>
  <div
    :class="props.iconless ? '' : 'form-group-feedback-left'"
    class="form-group form-group-feedback form-group-special"
  >
    <div class="input-group">
      <input
        :placeholder="props.placeholder"
        :value="props.modelValue"
        @input="onInput"
        class="form-control"
        type="text"
      >
      <span class="input-group-append" v-if="props.showSearchButton">
        <button @click="onSubmit" class="btn search-input--button">{{ props.actionText }}</button>
      </span>
    </div>
    <div class="form-control-feedback" v-if="!props.iconless">
      <search-icon class="d-inline-block opacity-25"/>
    </div>
  </div>
</template>

<script setup>
  import SearchIcon from '@/components/icons/search.vue';
  import { langService } from '@/core';

  const emit = defineEmits(['submit', 'update:modelValue']);

  const props = defineProps({
    modelValue: {
      type: null,
      default: null,
    },
    placeholder: {
      type: String,
      default() {
        return langService.trans('extra.search_placeholder');
      },
    },
    actionText: {
      type: String,
      default() {
        return langService.trans('actions.search');
      },
    },
    iconless: {
      type: Boolean,
      default: false,
    },
    showSearchButton: {
      type: Boolean,
      default: true,
    },
  });

  function onInput(event) {
    emit('update:modelValue', event.target.value);
  }

  function onSubmit() {
    emit('submit');
  }
</script>

